module.exports = __webpack_public_path__ + "img/5.431bde62.png";